import { render, staticRenderFns } from "./addHighSetting.vue?vue&type=template&id=a01c221c&scoped=true&"
import script from "./addHighSetting.vue?vue&type=script&lang=js&"
export * from "./addHighSetting.vue?vue&type=script&lang=js&"
import style0 from "./addHighSetting.vue?vue&type=style&index=0&id=a01c221c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01c221c",
  null
  
)

export default component.exports